import React from "react";

export function getFinalVplProjection(
  vplAnual: number[],
  defaultYears: number
) {
  if (vplAnual[defaultYears] !== undefined) {
    return { years: defaultYears, value: vplAnual[defaultYears] };
  }

  if (vplAnual[defaultYears - 1] !== undefined) {
    const years = vplAnual[0] === 0 ? defaultYears - 1 : defaultYears;
    return { years, value: vplAnual[defaultYears - 1] };
  }

  if (vplAnual.length > 1) {
    return { years: vplAnual.length - 1, value: vplAnual[vplAnual.length - 1] };
  }

  return { years: defaultYears, value: vplAnual[0] ?? 0 };
}

export function TIRPaybackTable({
  tir,
  paybackAnual,
  vplAnual,
  construindoUsina,
  construindoBateria,
}: {
  tir: number;
  paybackAnual: number;
  vplAnual: number[];
  construindoUsina: boolean;
  construindoBateria: boolean;
}) {
  let anosDeSimulacao = 10;
  if (construindoUsina) anosDeSimulacao = 25;
  else if (construindoBateria) anosDeSimulacao = 15;

  const vplProjection = getFinalVplProjection(vplAnual, anosDeSimulacao);

  return (
    <>
      <div className="economia-card">
        <h1>VPL ({vplProjection.years} anos)</h1>
        <h2>
          {vplProjection.value.toLocaleString("pt-BR", {
            style: "currency",
            currency: "BRL",
          })}
        </h2>
      </div>

      {vplProjection.value > 0 && (
        <>
          <div className="economia-card">
            <h1>TIR ({vplProjection.years} anos)</h1>
            <h2>{String(tir).replace(".", ",")}%</h2>
          </div>

          <div className="economia-card">
            <h1>Payback</h1>
            <h2>{String(paybackAnual).replace(".", ",")} ano(s)</h2>
          </div>
        </>
      )}
    </>
  );
}
